import React, { useState, useEffect } from "react";
import { StepProps } from "../../../config/types";

interface Step12Props extends StepProps {
  setStepValid: React.Dispatch<React.SetStateAction<boolean>>;
}

const Step12: React.FC<Step12Props> = ({
  handleChange,
  formValues,
  setStepValid,
}) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(
    formValues.q12_weight_management_program?.[0] || null
  );
  const [programDetails, setProgramDetails] = useState<string>(
    formValues
      .q12_please_provide_brief_details_of_weight_management_programs_you_ve_previously_tried?.[0] ||
      ""
  );

  useEffect(() => {
    const isStepValid =
      selectedOption !== null &&
      (selectedOption === "Yes" ? programDetails.trim() !== "" : true);
    setStepValid(isStepValid);

    if (selectedOption) {
      handleChange({
        target: {
          name: "q12_weight_management_program",
          value: [selectedOption],
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    }

    if (selectedOption === "Yes" && programDetails.trim() !== "") {
      handleChange({
        target: {
          name: "q12_please_provide_brief_details_of_weight_management_programs_you_ve_previously_tried",
          value: [programDetails],
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    }
  }, [selectedOption, programDetails, setStepValid]);

  const handleOptionChange = (value: string) => {
    setSelectedOption(value);
    if (value !== "Yes") {
      setProgramDetails("");
      handleChange({
        target: {
          name: "q12_please_provide_brief_details_of_weight_management_programs_you_ve_previously_tried",
          value: [""],
        },
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    }
  };

  const handleProgramDetailsChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setProgramDetails(e.target.value);
  };

  return (
    <div className="min-h-[50vh] lg:px-[50px] px-[0px] ">
      <p className="text-[#000000] text-[18px] font-[400] text-left mb-5">
        12. Have you ever attempted to lose weight in a weight management
        program, such as through caloric restriction, exercise, or behavior
        modification?
      </p>
      <div className="flex flex-row gap-[20px] items-center my-3 mb-7">
        <button
          type="button"
          onClick={() => handleOptionChange("Yes")}
          className={`min-h-[45px] rounded-[5px] min-w-[102px] border border-[#3B82F6] ${
            selectedOption === "Yes"
              ? "bg-[#3B82F6] text-white"
              : "text-[#000000] bg-[#ffffff]"
          }`}
        >
          Yes
        </button>
        <button
          type="button"
          onClick={() => handleOptionChange("No")}
          className={`min-h-[45px] rounded-[5px] min-w-[102px] border border-[#3B82F6] ${
            selectedOption === "No"
              ? "bg-[#3B82F6] text-white"
              : "text-[#000000] bg-[#ffffff]"
          }`}
        >
          No
        </button>
      </div>

      {selectedOption === "Yes" && (
        <div className="mt-4">
          <p className="text-[#000000] text-[18px] font-[400] text-left">
            Please provide brief details of weight management programs you’ve
            previously tried.
          </p>
          <textarea
            name="q12_please_provide_brief_details_of_weight_management_programs_you_ve_previously_tried"
            value={programDetails}
            onChange={handleProgramDetailsChange}
            className="w-full p-2 border border-gray-300 rounded mt-2"
            rows={5}
            placeholder="Please specify if any"
          />
        </div>
      )}
    </div>
  );
};

export default Step12;
